import Echo from "laravel-echo";
import { createFetchClient } from "./http.js";
import { createError } from "#app";
function createAuthorizer(app, authentication, logger) {
  const client = createFetchClient(app, authentication, logger);
  return (channel, _) => {
    return {
      authorize: (socketId, callback) => {
        const payload = JSON.stringify({
          socket_id: socketId,
          channel_name: channel.name
        });
        client(authentication.authEndpoint, {
          method: "post",
          body: payload
        }).then(
          (response) => callback(null, response)
        ).catch((error) => callback(error, null));
      }
    };
  };
}
function prepareEchoOptions(app, config, logger) {
  const forceTLS = config.scheme === "https";
  const additionalOptions = config.properties || {};
  const authorizer = config.authentication ? createAuthorizer(
    app,
    config.authentication,
    logger
  ) : void 0;
  if (config.broadcaster === "pusher") {
    if (!forceTLS) {
      throw createError('Pusher requires a secure connection (schema: "https")');
    }
    return {
      broadcaster: config.broadcaster,
      key: config.key,
      cluster: config.cluster,
      forceTLS,
      authorizer,
      ...additionalOptions
    };
  }
  if (config.broadcaster === "reverb") {
    return {
      broadcaster: config.broadcaster,
      key: config.key,
      wsHost: config.host,
      wsPort: config.port,
      wssPort: config.port,
      forceTLS,
      enabledTransports: config.transports,
      authorizer,
      ...additionalOptions
    };
  }
  throw new Error(`Unsupported broadcaster: ${config.broadcaster}`);
}
export function createEcho(app, config, logger) {
  const options = prepareEchoOptions(app, config, logger);
  return new Echo(options);
}
